import React from "react"
import {Link} from "react-router-dom"
import {
    contextMenuItem,
    getIcon,
    isGoogleImage,
    proxyImage
} from "../functions"
import linkImg from "../images/link-logo-default.png"
import {MenuItem} from "./MenuItem"

export class GoogleFileElement extends React.Component {
    render() {
        const {k, l, item, iconsObject, isGoogleDisc, isTrash} = this.props
        // console.log("isGoogleDisc=", isGoogleDisc)
        // console.log("isTrash=", isTrash)

        // Выбираем изображение: thumbUrl или fallback
        const imgGoogleFile = proxyImage(item.thumbUrl) || getIcon(item['webViewLink'], linkImg)
        const linkViewImage = proxyImage(item.linkViewImage)
        const enc = (v) => encodeURIComponent(v || '')

        const menuItemData = {
            key: k,
            item: item['type'],
            id: item['id'],
            googleParent: item['parentFID'] || 'root',
            name: item['name'],
            thumb: imgGoogleFile,
            parent: item['parentFolder']
        }

        let webLink = `/${l}/google-drive-view/from?link=${enc(item['webViewLink'])}&mime-type=${enc(item.mimeType)}&linkViewImage=${enc(linkViewImage)}`
        if (isGoogleImage(item)) {
            webLink = `/${l}/link/image-slide/${menuItemData.id}`
        }

        return (
            <div>
                <div className={"d-flex justify-content-center position-relative"}>
                    {isGoogleDisc && isTrash && <Link
                        to={webLink}
                        className={'link-link'}
                        target="_blank"
                        rel="noreferrer noopener">
                        <div className="hand-click"
                             style={{
                                 width: 75,
                                 height: 75,
                                 overflow: "hidden",
                                 borderRadius: "8px", // как папки
                                 display: "flex",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 backgroundColor: "#f0f0f0", // фон на случай прозрачных миниатюр
                             }}>
                            <img id={"img-google-file"}
                                 src={imgGoogleFile}
                                 alt={item.name}
                                 style={{
                                     width: "100%",
                                     height: "100%",
                                     objectFit: "cover",
                                 }}
                            />
                        </div>
                    </Link>}
                    {isGoogleDisc && !isTrash && <Link to={''} className={'link-link'}>
                        <div className="hand-click"
                             style={{
                                 width: 75,
                                 height: 75,
                                 overflow: "hidden",
                                 borderRadius: "8px", // как папки
                                 display: "flex",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 backgroundColor: "#f0f0f0", // фон на случай прозрачных миниатюр
                             }}>
                            <img id={"img-google-file"}
                                 src={imgGoogleFile}
                                 alt={item.name}
                                 style={{
                                     width: "100%",
                                     height: "100%",
                                     objectFit: "cover",
                                 }}
                            />
                        </div>
                    </Link>}
                    {isGoogleDisc && isTrash && <div>
                        <MenuItem data={menuItemData}/>
                        <div className={'hand-click'}
                             onClick={(e) => {
                                 contextMenuItem(e, k)
                             }}>
                            <img id={"img-context-menu"} src={iconsObject['img_context_menu_google']}
                                 className={"w-100 rounded-2"}
                                 alt={"..."}/>
                        </div>
                    </div>}
                </div>
                <p id={"name-file"}
                   className={"name-folder text-center mb-2 text-black p-0 fw-bold"}>{item.name}
                </p>
            </div>
        )
    }
}
